import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${ColorPalette.HEX.Lotion};
    min-height: 100%;
    padding: 40px 16px 16px;
  }
`;

export const StyledButton = styled(Button)`
  margin-top: 40px;
  margin-bottom: 16px;
  height: 56px;
`;

export const Content = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: repeat(3, 33%);
    grid-gap: 5px;
  }
`;

export const ErrorValidation = styled.span`
  padding-top: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.primaryBackgroundColor};
`;
